import React from "react";
import MedicoTerceiroSteps from "./steps/MedicoTerceiroSteps";
import { MedicoTerceiroStoreProvider } from '../../../context/MedicoTerceiroContext';

export default function MedicoTerceiro() {

    return (
        <MedicoTerceiroStoreProvider>
            <MedicoTerceiroSteps />
        </MedicoTerceiroStoreProvider>
    )

}